export default __webpack_public_path__ + "static/snap_compare_auto_15m_tag-9a6ec1b2a11e09e9cd1c85cf011ad4ce.webp";